var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrochipFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1064_335",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.32 0H0V61.32H47.48L61.32 47.48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1064_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3201 47.4805L47.4802 61.3203H31.3552L49.3894 43.332L49.8308 42.8926V25.5137C51.1375 24.9367 52.0504 23.6306 52.0505 22.1104C52.0505 20.0559 50.3843 18.3896 48.3298 18.3896C46.2755 18.3898 44.6101 20.056 44.6101 22.1104C44.6102 23.631 45.5235 24.937 46.8308 25.5137V41.6465L27.1072 61.3203H11.9685L35.6589 37.7129L36.1003 37.2725V19.6318C37.4055 19.0534 38.3199 17.7466 38.3201 16.2305C38.3201 14.1706 36.6502 12.5099 34.6003 12.5098C32.5503 12.5098 30.8796 14.1805 30.8796 16.2305C30.8798 17.7468 31.7948 19.0536 33.1003 19.6318V36.0264L7.71948 61.3203H-0.000244141V55.0605L22.7507 32.3008L23.1902 31.8613V14.252C24.4956 13.6735 25.4099 12.366 25.4099 10.8496C25.4097 8.78983 23.74 7.12995 21.6902 7.12988C19.6403 7.12988 17.9707 8.79979 17.9705 10.8496C17.9705 12.3661 18.8846 13.6736 20.1902 14.252V30.6191L-0.000244141 50.8174V0H61.3201V47.4805Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrochipFilled);
export default __webpack_public_path__ + "static/media/Microchip-Filled.494f796b54eedcff9d486a4b20a3df17.svg";
export { ForwardRef as ReactComponent };